import React, { useState } from "react";

export default function Shop({ username }) {
  const [activeTab, setActiveTab] = useState("buy");
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [transactionId, setTransactionId] = useState("");
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [upiId, setUpiId] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const packages = [
    { pebbles: 80, price: 100, popular: false },
    { pebbles: 400, price: 500, popular: true },
    { pebbles: 800, price: 1000, popular: false },
    { pebbles: 4000, price: 5000, popular: false },
  ];

  const handleBuy = async (e) => {
    e.preventDefault();
    if (!transactionId.trim()) return;
    setLoading(true);
    setMessage("");
    
    try {
      const API = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
        ? "http://localhost:5000"
        : (process.env.REACT_APP_API_URL || "http://localhost:5000");
      const res = await fetch(`${API}/deposit/request`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username,
          amount: selectedPackage.pebbles,
          method: "UPI",
          transactionId: transactionId.trim()
        })
      });
      const data = await res.json();
      if (res.ok) {
        setMessage("✅ Request submitted! Pebbles will be added once verified.");
        setSelectedPackage(null);
        setTransactionId("");
      } else {
        setMessage(`❌ Error: ${data.message}`);
      }
    } catch (err) {
      setMessage("❌ Network error. Please try again.");
    }
    setLoading(false);
  };

  const handleWithdraw = async (e) => {
    e.preventDefault();
    const amount = Number(withdrawAmount);
    if (isNaN(amount) || amount <= 0) {
      setMessage("❌ Please enter a valid positive amount.");
      return;
    }
    if (!upiId.trim()) {
      setMessage("❌ Please enter a valid UPI ID.");
      return;
    }
    setLoading(true);
    setMessage("");

    try {
      const API = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
        ? "http://localhost:5000"
        : (process.env.REACT_APP_API_URL || "http://localhost:5000");
      const res = await fetch(`${API}/withdrawal/request`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username,
          amount,
          method: "UPI",
          details: { upiId: upiId.trim() }
        })
      });
      const data = await res.json();
      if (res.ok) {
        setMessage(`✅ Withdrawal request of ${amount} Pebbles submitted successfully!`);
        setWithdrawAmount("");
        setUpiId("");
      } else {
        setMessage(`❌ Error: ${data.message}`);
      }
    } catch (err) {
      setMessage("❌ Network error. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div style={{
      maxWidth: 600, margin: "0 auto", padding: "0 0 100px",
      fontFamily: "inherit", color: "var(--text)"
    }}>
      <div style={{
        background: "linear-gradient(135deg, #1f1b2e 0%, #110e1b 100%)",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: 20,
        padding: "24px 20px",
        marginBottom: 20,
        boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
        textAlign: "center"
      }}>
        <h2 style={{ fontSize: 24, margin: "0 0 6px 0", color: "#ffd166", fontWeight: 800 }}>💎 Pebble Shop & Exchange</h2>
        <p style={{ fontSize: 13, color: "var(--muted)", margin: 0 }}>Deposit or withdraw your hard-earned Pebbles instantly.</p>
      </div>

      {message && (
        <div style={{
          background: message.includes("❌") ? "rgba(239, 68, 68, 0.15)" : "rgba(16, 185, 129, 0.15)",
          color: message.includes("❌") ? "#ef4444" : "#10b981",
          border: `1px solid ${message.includes("❌") ? "#ef444433" : "#10b98133"}`,
          padding: "12px 16px", borderRadius: 12, marginBottom: 20,
          fontSize: 13, fontWeight: 600, textAlign: "center"
        }}>
          {message}
        </div>
      )}

      {/* Tabs */}
      <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
        <button 
          onClick={() => { setActiveTab("buy"); setMessage(""); }}
          style={{
            flex: 1, padding: "12px 0", borderRadius: 12, cursor: "pointer",
            border: activeTab === "buy" ? "1px solid rgba(255,255,255,0.15)" : "1px solid rgba(255,255,255,0.04)",
            background: activeTab === "buy" ? "rgba(255,255,255,0.08)" : "transparent",
            color: activeTab === "buy" ? "#ffd166" : "var(--muted)",
            fontSize: 13, fontWeight: 700, transition: "all 0.2s"
          }}
        >
          📥 Buy Pebbles
        </button>
        <button 
          onClick={() => { setActiveTab("withdraw"); setMessage(""); }}
          style={{
            flex: 1, padding: "12px 0", borderRadius: 12, cursor: "pointer",
            border: activeTab === "withdraw" ? "1px solid rgba(255,255,255,0.15)" : "1px solid rgba(255,255,255,0.04)",
            background: activeTab === "withdraw" ? "rgba(255,255,255,0.08)" : "transparent",
            color: activeTab === "withdraw" ? "#ef4444" : "var(--muted)",
            fontSize: 13, fontWeight: 700, transition: "all 0.2s"
          }}
        >
          💸 Withdraw Pebbles
        </button>
      </div>

      {activeTab === "buy" ? (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
          {packages.map((pkg, i) => (
            <div 
              key={i} 
              style={{
                background: "var(--surface)",
                border: pkg.popular ? "2px solid #ffd166" : "1px solid var(--border)",
                borderRadius: 16,
                padding: 20,
                textAlign: "center",
                position: "relative",
                display: "flex", flexDirection: "column", justifyContent: "space-between"
              }}
            >
              {pkg.popular && (
                <div style={{
                  position: "absolute", top: -10, left: "50%", transform: "translateX(-50%)",
                  background: "#ffd166", color: "#000", padding: "2px 8px", borderRadius: 99,
                  fontSize: 10, fontWeight: 800, textTransform: "uppercase"
                }}>
                  Best Value
                </div>
              )}
              <div style={{ fontSize: 22, fontWeight: 800, color: "#ffd166", marginBottom: 4 }}>
                💎 {pkg.pebbles.toLocaleString()}
              </div>
              <div style={{ fontSize: 11, color: "var(--muted)", marginBottom: 16 }}>Pebbles</div>
              <button 
                onClick={() => setSelectedPackage(pkg)}
                style={{
                  background: "var(--accent)", color: "#fff",
                  border: "none", padding: "8px 12px", borderRadius: 8,
                  fontSize: 12, fontWeight: 700, cursor: "pointer", width: "100%"
                }}
              >
                Buy for ₹{pkg.price}
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div style={{
          background: "var(--surface)", border: "1px solid var(--border)",
          borderRadius: 16, padding: 24
        }}>
          <h3 style={{ margin: "0 0 16px 0", fontSize: 16 }}>Withdraw your Pebbles</h3>
          <form onSubmit={handleWithdraw}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", fontSize: 11, color: "var(--muted)", marginBottom: 6, fontWeight: 600 }}>PEBBLE AMOUNT TO WITHDRAW</label>
              <input 
                type="number" 
                placeholder="e.g. 500" 
                value={withdrawAmount}
                onChange={e => setWithdrawAmount(e.target.value)}
                required
                style={{
                  width: "100%", padding: "10px 12px", borderRadius: 8,
                  background: "var(--bg)", border: "1px solid var(--border)", color: "var(--text)",
                  fontSize: 14, boxSizing: "border-box", outline: "none"
                }}
              />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: "block", fontSize: 11, color: "var(--muted)", marginBottom: 6, fontWeight: 600 }}>UPI ID (VPA)</label>
              <input 
                type="text" 
                placeholder="yourname@upi" 
                value={upiId}
                onChange={e => setUpiId(e.target.value)}
                required
                style={{
                  width: "100%", padding: "10px 12px", borderRadius: 8,
                  background: "var(--bg)", border: "1px solid var(--border)", color: "var(--text)",
                  fontSize: 14, boxSizing: "border-box", outline: "none"
                }}
              />
            </div>
            <button 
              type="submit" 
              disabled={loading || !withdrawAmount || !upiId}
              style={{
                width: "100%", background: "var(--accent)", color: "#fff",
                border: "none", padding: "12px", borderRadius: 8,
                fontSize: 13, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer",
                opacity: loading ? 0.6 : 1
              }}
            >
              {loading ? "Submitting..." : "Submit Withdrawal Request"}
            </button>
          </form>
        </div>
      )}

      {selectedPackage && (
        <div style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)",
          display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: 16
        }}>
          <div style={{
            background: "var(--bg)", border: "1px solid var(--border)", borderRadius: 16,
            width: "100%", maxWidth: 420, overflow: "hidden"
          }}>
            <div style={{
              padding: "16px 20px", borderBottom: "1px solid var(--border)",
              display: "flex", justifyContent: "space-between", alignItems: "center"
            }}>
              <h3 style={{ margin: 0, fontSize: 16 }}>Purchase {selectedPackage.pebbles} Pebbles</h3>
              <button 
                onClick={() => setSelectedPackage(null)}
                style={{ background: "none", border: "none", color: "var(--muted)", fontSize: 22, cursor: "pointer" }}
              >
                ✕
              </button>
            </div>
            
            <div style={{ padding: 20 }}>
              <p style={{ margin: "0 0 12px 0", fontSize: 14 }}>Please pay <b>₹{selectedPackage.price}</b> to the UPI ID below:</p>
              <div style={{
                background: "rgba(255,255,255,0.04)", border: "1px dashed rgba(255,255,255,0.2)",
                padding: "10px 14px", borderRadius: 8, fontSize: 16, fontWeight: 700, textAlign: "center",
                color: "#ffd166", marginBottom: 12
              }}>
                crickbet@upi
              </div>
              <p style={{ fontSize: 11, color: "var(--muted)", margin: "0 0 16px 0" }}>After payment, enter your 12-digit UTR / Transaction ID below to verify.</p>

              <form onSubmit={handleBuy}>
                <input 
                  type="text" 
                  placeholder="Enter Transaction ID (UTR)" 
                  value={transactionId}
                  onChange={e => setTransactionId(e.target.value)}
                  required
                  style={{
                    width: "100%", padding: "10px 12px", borderRadius: 8,
                    background: "var(--surface)", border: "1px solid var(--border)", color: "var(--text)",
                    fontSize: 14, boxSizing: "border-box", outline: "none", marginBottom: 16
                  }}
                />
                <button 
                  type="submit" 
                  disabled={loading || !transactionId.trim()}
                  style={{
                    width: "100%", background: "var(--accent)", color: "#fff",
                    border: "none", padding: "12px", borderRadius: 8,
                    fontSize: 13, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer",
                    opacity: loading ? 0.6 : 1
                  }}
                >
                  {loading ? "Submitting..." : "Submit Payment"}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
